var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: _vm.bemBlock },
    [
      _c("BaseStoreLocatorForm", {
        attrs: { url: _vm.url || _vm.defaultUrl },
        on: { "store-locator:result": _vm.handleResults }
      }),
      _vm._v(" "),
      _c("div", {
        class: _vm.bemElement("container"),
        domProps: { innerHTML: _vm._s(_vm.storeLocatorContent) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }